import { queryOptions } from '@tanstack/react-query';
import { api, call } from '@/lib/api';
import { qk } from '@/lib/query-keys';

// Accès à `/api/v1/dashboard` (`api.md` § Tableau de bord et calibration, fiche T29). Une seule
// route sert la page d'accueil : tuiles, panneaux, budget du mois et compteur de la sidebar.

export type DashboardData = Awaited<ReturnType<typeof getDashboard>>;

/** `staleTime` du tableau de bord : 60 s (`frontend.md` § 3). */
export const DASHBOARD_STALE_TIME = 60_000;

export function getDashboard(marketId: string | undefined) {
  return call(api.dashboard.$get({ query: marketId ? { marketId } : {} }));
}

export const dashboardQueryOptions = (marketId: string | undefined) =>
  queryOptions({
    queryKey: qk.dashboard(marketId),
    queryFn: () => getDashboard(marketId),
    staleTime: DASHBOARD_STALE_TIME,
  });
